import * as Yup from 'yup';
import { passwordValidationRule } from './passwordValidationRule';

export const resetPasswordFormValidationSchema = Yup.object().shape({
  Password: passwordValidationRule,
});
